import { TbCurrencyDollarCanadian } from 'react-icons/tb';

const AssociateRequestExperience = ({
  fieldOfExpertise,
  perHourRate,
  yearsOfExperience,
  businessRegNo,
  hstNumber,
  licenseNumber,
}: {
  fieldOfExpertise: string;
  yearsOfExperience: number;
  perHourRate: number;
  businessRegNo: string;
  hstNumber: string;
  licenseNumber: string;
}) => {
  // rendering associate request experience component here
  return (
    <div className='mt-5 space-y-3'>
      <div className='grid grid-cols-1 md:grid-cols-3 gap-3'>
        <div className='text-center space-y-1 bg-gray-100 rounded-lg py-3 px-1'>
          <p className='text-sm text-legal-dark-blue font-semibold'>
            Business Registration No.
          </p>

          <p className='text-center text-xl text-base-light-blue font-semibold'>
            {businessRegNo}
          </p>
        </div>

        <div className='text-center space-y-1 bg-gray-100 rounded-lg py-3 px-1'>
          <p className='text-sm text-legal-dark-blue font-semibold'>
            HST/TIN Number
          </p>

          <p className='text-center text-xl text-base-light-blue font-semibold'>
            {hstNumber}
          </p>
        </div>

        <div className='text-center space-y-1 bg-gray-100 rounded-lg py-3 px-1'>
          <p className='text-sm text-legal-dark-blue font-semibold'>
            License Number
          </p>

          <p className='text-center text-xl text-base-light-blue font-semibold'>
            {licenseNumber}
          </p>
        </div>
      </div>

      <div className='flex flex-col items-center justify-center text-center space-y-1 bg-gray-100 py-3 px-1 rounded-lg'>
        <p className='text-sm text-legal-dark-blue font-semibold'>
          Field of Expertise
        </p>

        <p className='flex items-center justify-center text-xl text-base-light-blue font-semibold'>
          {fieldOfExpertise}
        </p>
      </div>

      <div className='grid grid-cols-2 gap-3'>
        <div className='text-center space-y-1 bg-gray-100 py-3 px-1 rounded-lg'>
          <p className='text-sm text-legal-dark-blue font-semibold'>
            Years of Experience
          </p>

          <p className='flex items-center justify-center text-xl text-base-light-blue font-semibold'>
            {yearsOfExperience} Years
          </p>
        </div>

        <div className='text-center space-y-1 bg-gray-100 py-3 px-1 rounded-lg'>
          <p className='text-sm text-legal-dark-blue font-semibold'>
            Expected Hourly Rate
          </p>

          <div className='flex items-center justify-center text-base-light-blue'>
            <TbCurrencyDollarCanadian className='size-6' />
            <p className='flex items-center justify-center text-xl font-semibold'>
              {perHourRate}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssociateRequestExperience;
